export default "__VITE_ASSET__DSwreiL$__"